<template>
  <div class="row row-cols-8 row-cols-md-6  g-4 m-2">
    <div class="col" v-for="(r) in routes" :key="r">
      <div class="card h-100" style="width: 18rem;">
        <div class="card-body">
          <a v-bind:href="'/branch/' + r">{{ r }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import 'swagger-ui/dist/swagger-ui.css';

export default {
  data() {
    return {
      routes: []
    }
  },
  async created() {
    let routes = await fetch('/branch/list')
        .then(r => r.text())
        .then(r => r.split('\n'))
    routes = [...new Set(routes)];
    this.routes = routes;
  }
}
</script>